/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function createResourceCopy(sourceModel: any, overrides: Record<string, any>): any {
  const copyData = _.cloneDeep(sourceModel);
  Object.assign(copyData, overrides);
  return copyData;
}
